<template>
  <div class="content-box">
	  <HconTitle subTitle="장바구니" />
    <div class="sub-wrapper block">
      <div class="border-title check">
        <div class="lft-txt">
          <HconCheckBox type="checkTitle" label="선택상품" v-model:checked="isAllChecked" :num="seletedCount" name="allCheckBtn" labelClass="top-check-title" :hide-label="false" />
        </div>
        <p class="rgt-txt">
          <span class="total">총 <em class="count">{{items.length}}</em>건</span>
          <span class="text-gray">(최대 <span class="count">20</span>건)</span>
        </p>
      </div>
    </div>

      <div class="sheet-container">
        <template v-if="items.length > 0">
          <div class="sheet-wrapper">
            <ul class="sheet-list">
            <HconCartItem v-for="item in items" :key="item.id" :item="item" :isSelected="selectedIds.includes(item.id)"
                          @change="handleCheck" @add-item="createQuotation" @buy-item="buyItem" @delete-item="removeBasket" />
            </ul>
          </div>
        <Transition name="fade">
          <div v-if="isVisabled" class="alert-msg">
            <p>
              일부 상품은 <em>품절 또는 구매 제한으로 주문 및 견적 담기가 불가</em>합니다.<br />
              해당 상품을 제외하거나 장바구니를 수정한 후 진행해 주세요.
            </p>
            <button type="button" class="btn-delete01" @click="closeAlert"></button>
          </div>
        </Transition>
          <div class="button-box mt20 jc-l">
            <button type="button" class="btn btn-outline" @click="removeBasketList">선택상품 삭제</button>
          </div>
          <div class="button-box col2 mt40">
            <button type="button" class="btn lg btn-outline" @click="createQuotationList">선택상품 견적담기</button>
            <button type="button" class="btn lg tooltip-btn" :disabled="canPay" @click="buyItemList">선택상품 바로구매</button>
            <div class="tooltip">
              <p>선택하신 상품마다 결제수단이 달라 함께 주문할 수 없습니다.</p>
            </div>
          </div>
        </template>
        <div v-else class="no-data mt120 pb60">
          <img src="@/assets/images/pc/icon-hcon/icon-cart-nodata.svg" alt="" width="40px" height="36px" />
            <p>장바구니에 담긴 상품이 없습니다.</p>
        </div>
    </div>
    <div class="box-gray inset40 mt80">
      <h4 class="title">장바구니 안내</h4>
      <ul class="dot-list mt24">
        <li>장바구니에는 최대 20개 상품까지 담을 수 있습니다.</li>
        <li>담아둔 상품도 재고가 없거나 품절되면 잠시 구매가 제한될 수 있습니다.</li>
      </ul>
    </div>
  </div>

  <!-- 담긴상품불러오기 팝업 -->
  <HconAddedGoodsImport :flag=true ref="popupAddedGoodsImportRef" />

</template>
<script lang="ts" setup>
import HconTitle from '@/components/com/HconComPCTitle.vue'
import HconCheckBox from '@/components/com/HconComPCCheckbox.vue'
import HconCartItem from '@/components/corner/pc/HconCornerCartItemPC.vue'
import HconAddedGoodsImport from '@/components/popup/HconAddedGoodsImport.vue'

import { checkCommonPayment } from '~/utils/payment/payment-utils'
import { ORDER_CODE, ESTIMATE_CODE } from "@/constants/hconMessageConstants"
import { usePopup } from '@/composables/hconUsePopup'
import { ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import type { BasketResDto } from '~/types/basket/backend-dto-types'
const { refreshCnt } = useHeader()
//////////////////////////////////////////////
// 초기 화면 로드 & 기본 세팅
//////////////////////////////////////////////

definePageMeta({label:'장바구니', movable: false})
const { showAlert, showConfirm } = usePopup() // 팝업 준비
const fetchBuilder  = useHconFetchBuilder() // API 호출 준비
const router = useRouter() 
const items = ref<any[]>([])  // 장바구니 목록
const selectedIds = ref<String[]>([]) // 체크 대상
const canPay = ref(false) // 선택상품 바로구매 버튼 제어
let finalBskNoList: String[] = [];

// 화면 마운트
onMounted(() => {
  getBasketList()
})

interface PaymentMethods {
  hcoin: boolean
  pcoin: boolean
  card: boolean
  account: boolean
}

export interface CartItemType {
  id: number
  gdsCd: string
  dspGdsCd: string
  company: string
  name: string
  option: string
  validity: string
  discount: string
  price: number
  originalPrice?: number
  thumb: string
  alt: string
  isSoldOut: boolean
  badge?: string
  payments: PaymentMethods
}

// alert msg
const isVisabled = ref(false)
let timer: ReturnType<typeof setTimeout> | null = null

const closeAlert = () => {
  isVisabled.value = false
  if (timer) clearTimeout(timer)
}

// #######################################################################

// 체크박스 클릭 시 - 배열에 데이터 입력
const handleCheck = (event: Event) => {
  const target = event.target as HTMLInputElement | null
  if(target) {
    const id = target.id.replace('item-', '')
    const index = selectedIds.value.indexOf(id)
    if(index > -1) {
      selectedIds.value.splice(index, 1)
    } else {
      selectedIds.value.push(id)
    }

    if(selectedIds.value.length !== 0) {
      const tmpChkList = items.value.filter(target => 
        selectedIds.value.includes(target.id)
      )
      canPay.value = !checkCommonPayment(tmpChkList)
    }
  }
}

// 체크된 select 갯수
const seletedCount = computed(() => 
  selectedIds.value.length
)

// 체크박스 - 전체 클릭
const isAllChecked = computed({
  get() {
    return selectedIds.value.length > 0 && selectedIds.value.length === items.value.length
  },
  set(val) {
    if(val) {
      selectedIds.value = items.value.map(item => item.id)
      if(selectedIds.value.length !== 0) {
        canPay.value = !checkCommonPayment(items.value)
      }
    } else {
      selectedIds.value = []
      canPay.value = false
    } 
  }
})
  
// 장바구니 목록 조회
const getBasketList = async () => {
  const fetchBuilderResult = 
    fetchBuilder.get<AjaxResult<BasketResDto[]>>('/api/v1/order/shopping-basket/list')
    .build()
    .execute()
    .then(res => {
      if(res.resultCode != '200') {
        showAlert({
          title: '알림',
          message: res.resultMessage,
          confirmText: '확인'
        })
      } else {
        const dataMap = res.data.map((item) => ({
          id: item.bsktNo,
          company: item.brndNm,
          gdsCd: item.hcGdsCd,
          dspGdsCd: item.hcDspGdsCd,
          name: item.hcDspGdsNm,
          badge: item.mssBuyGdsYn === 'Y' ? '대량구매 ' + HconCommonUtils.format.expComma(item.buyPossMinQty) + '개' : '',
          validity: '유효기간 ' + item.vlidTermDcnt + '일',
          discount: item.dcRt,
          price: item.realSellPrc,
          originalPrice: item.nrmlSellPrc,
          thumb: cu.getFileFullUrl(item.cpnTnailImgPath), 
          alt: item.hcDspGdsNm,
          payments: {   hcoin: item.hcashPymtPossYn === 'Y' ? true : false
                      , pcoin: item.mlgPymtPossYn === 'Y' ? true : false
                      , card: item.crdPymtPossYn === 'Y' ? true : false
                      , account: item.acntTrnsPossYn === 'Y' ? true : false },
          isCshabGdsYn: item.cshabGdsYn === 'Y' ? true : false,
          isSoldOut: item.buyPossYn === 'Y' ? false : true
        }))
        items.value = dataMap
      }
    })
}

let gdsList: {}[] = []  // 상품리스트

// 상품리스트 세팅
const chkGdsList = (bskNoList: any) => {
  const tmpGdsList = items.value.filter(target => 
    bskNoList.includes(target.id)
  )

  gdsList = tmpGdsList.map(item => ({
    hcDspGdsCd: item.dspGdsCd,
    hcGdsCd: item.gdsCd
  }))

  return gdsList
}

// 바로구매 단건
const buyItem = async (item: any) => {

  // 파라미터 확인
  const bskNo = [item][0];

  // 상품 상태 체크
  const chkResult = await chkStatusGds(bskNo) as {res: boolean}

  if(chkResult.res) {
    
    chkGdsList([bskNo]) // 상품리스트 세팅
    
    // 주문서 이동
    router.push({
      path: '/pc/order/application-form',
      state: {
        prevPage: 'C',
        gdsList: JSON.parse(JSON.stringify(gdsList as string[]))
      }
    })
  }
}


// 바로구매 다건(선택상품)
const buyItemList = async () => {

  // 파라미터 확인    
  const bskNoList = selectedIds.value

  if(bskNoList.length != 0) {

    // 상품 상태 체크
    const chkResult = await chkStatusGds("") as {res: boolean}
    
    if(chkResult.res) {

      chkGdsList(bskNoList) // 상품리스트 세팅
    
      // 주문서 이동
      router.push({
        path: '/pc/order/application-form',
        state: {
          prevPage: 'C',
          gdsList: JSON.parse(JSON.stringify(gdsList as string[]))
        }
      })
    }

  } else {
    showAlert({
      title: '알림',
      message: ORDER_CODE.ALT_HCON_9126,
      confirmText: '확인'
    })
  }
}

// 품절 상품 포함 시 메시지 노출
const showSoldOutMsg = ()  => {

  if (timer) {
    clearTimeout(timer) 
  }

  isVisabled.value = true
  timer = setTimeout(() => {
    isVisabled.value = false 
  }, 3000)
}

// 상품 상태 체크
const chkStatusGds = async (bskNo: any) => {

  // 파라미터 확인
  const bskNoList = bskNo.length === 0 ? selectedIds.value : bskNo
  finalBskNoList = [] // 배열 초기화

  // 1. 품절 체크
  const chkSoldOut = items.value.filter(target => 
    bskNoList.includes(target.id) && target.isSoldOut === true
  )

  return new Promise(async (resolve) => {

    if(chkSoldOut.length > 0) {
      showSoldOutMsg()
      resolve({res: false})
      return
    } else {
      finalBskNoList = bskNoList // 품절 없음
    }

    // 2. 환금성상품 체크
    const chkCshabGds = items.value.filter(target => 
      bskNoList.includes(target.id) && target.isCshabGdsYn === true
    )

    if(chkCshabGds.length > 0) {

      // API 호출
      const response = await fetchBuilder.get<AjaxResult<any>>('/api/v1/order/check-trading-time')
        .progressMessage("잠시만 기다려주세요...")
        .build()
        .execute()

      if(response.resultCode != '200') {
        showAlert(response.resultMessage)
        resolve({res: false})
        return 
      } else {
        if(response.data.message === 'SUCESS') {
          const resultConfirm = await showCshabGdsInclConfirm()
          if (!resultConfirm) {
            resolve({res: false})
            return
          } else if ("etc" === resultConfirm) {
            resolve({res: false})
            return 
          }
        } else { // 주문 불가인 경우
          showAlert({
            title: '알림',
            message: ORDER_CODE.ALT_HCON_9218,
            confirmText: '확인'
          })
          resolve({res: false})
          return 
        }
      }
    }

    resolve({res: true})
  })
}

// 장바구니 상품 단건 삭제(논리삭제)
const removeBasket = async (item: any) => {
  // 컨펌 팝업
  const confirmResult = showRemoveConfirm();
  if( await confirmResult) {
    // 파라미터 확인
    const bskNo = [item];

    // API 호출
    const fetchBuilderResult = 
    fetchBuilder.put<AjaxResult<Number>>('/api/v1/order/shopping-basket/delete/by-case')
    .body({
        bsktNoList: bskNo
      })
    .progressMessage("잠시만 기다려주세요...")
    .build()
    .execute()
    .then((result) => {
      if(result.resultCode != '200') {
        showAlert({
          title: '알림',
          message: result.resultMessage,
          confirmText: '확인'
        })
      } else {
        refreshCnt();
        // 성공시 화면에서 단건 삭제
        const targetIndex = items.value.findIndex(item => {
            return item.id === bskNo[0]
          }
        )

        if(targetIndex > -1) {
          const targetIndexSelected = selectedIds.value.findIndex(item => {
            return item === items.value[targetIndex].id
          })
          
          if(targetIndexSelected > -1) {
            selectedIds.value.splice(targetIndexSelected, 1);
          }

          items.value.splice(targetIndex, 1);
        }

      }
    })
  }
}

// 장바구니 상품 다건 삭제(논리삭제)
const removeBasketList = async () => {
  // 파라미터 확인    
  const bskNoList = selectedIds.value

  if(bskNoList.length != 0) {
    // 컨펌 팝업
    const confirmResult = showRemoveConfirm();
    if(await confirmResult) {
      // API 호출
      const fetchBuilderResult = 
      fetchBuilder.put<AjaxResult<Number>>('/api/v1/order/shopping-basket/delete/by-case')
      .body({
        bsktNoList: bskNoList
      })
      .progressMessage("잠시만 기다려주세요...")
      .build()
      .execute()
      .then((result) => {
        if(result.resultCode != '200') {
          showAlert({
            title: '알림',
            message: result.resultMessage,
            confirmText: '확인'
          })
        } else {
          refreshCnt();
          // 성공시, 선택되지 않은 배열들로 화면 다시 그리기
          const targetList = items.value.filter(item => {
            return !bskNoList.includes(item.id)
          })

          items.value.splice(0, items.value.length);
          selectedIds.value.splice(0, selectedIds.value.length);
          
          if(targetList.length > 0) {
            items.value.push(... targetList);
          }
        }
      })
    }
  } else {
    showAlert({
      title: '알림',
      message: ORDER_CODE.ALT_HCON_9126,
      confirmText: '확인'
    })
  }
}

// 장바구니 상품 삭제 전 컨펌 팝업
const showRemoveConfirm = async() => {
  const result = await showConfirm({
    title: '장바구니 삭제',
    message: ORDER_CODE.ALT_HCON_9055,
    confirmText: '확인',
    cancelText: '취소'
  })
  return result;
}

// 견적담기 컨펌관련
let confirmTitle = "";
let confirmMessage = "";
let confirmText = "";

// 견적담기 단건
const createQuotation = async (item: any) => {
  
  // 품절체크
  const chkSoldOut = items.value.filter(target => 
    target.id === [item][0] && target.isSoldOut === true
  )

  if(chkSoldOut.length > 0) {
    showSoldOutMsg()
    return
  }
    
  // 상품리스트 세팅
  chkGdsList([[item][0]])

  // API 호출
  const fetchBuilderResult = 
    fetchBuilder.post<AjaxResult<any>>('/api/v1/order/estimate/items')
    .body({
        gdsList: gdsList
      })
    .progressMessage("잠시만 기다려주세요...")
    .build()
    .execute()
    .then((result) => {
      if(result.resultCode != '200') {
        showAlert({
          title: '알림',
          message: result.resultMessage,
          confirmText: '확인'
        })
      } else {
        resConfirm(result.data.message)
      }        
    })
}

// 견적담기 다건
const createQuotationList = async () => {

  // 파라미터 확인    
  const bskNoList = selectedIds.value

  // 품절체크
  const chkSoldOut = items.value.filter(target => 
    bskNoList.includes(target.id) && target.isSoldOut === true
  )

  if(chkSoldOut.length > 0) {
    showSoldOutMsg()
    return
  }

  if(bskNoList.length != 0) {
    
    // 상품리스트 세팅
    chkGdsList(bskNoList)

    // API 호출
    const fetchBuilderResult = 
      fetchBuilder.post<AjaxResult<any>>('/api/v1/order/estimate/items')
      .body({
        gdsList: gdsList
      })
      .progressMessage("잠시만 기다려주세요...")
      .build()
      .execute()
      .then((result) => {
        refreshCnt();
        if(result.resultCode != '200') {
          showAlert({
            title: '알림',
            message: result.resultMessage,
            confirmText: '확인'
          })
        } else {
          resConfirm(result.data.message)
        }
      })
  } else {
    showAlert({
      title: '알림',
      message: ORDER_CODE.ALT_HCON_9126,
      confirmText: '확인'
    })
  }
}

// 컴펌관련
const resConfirm = async (tmpMessage: any) => {
  if(tmpMessage === "QuantityOver") { // 수량 초과
    confirmTitle = "견적 담기 제한 수량 초과"
    confirmMessage = ESTIMATE_CODE.ALT_HCON_9059;
    confirmText = "담긴 상품 불러오기"
  } else if(tmpMessage === "DuplicateProduct") { // 중복
    confirmTitle = "견적 담기"
    confirmMessage = ESTIMATE_CODE.ALT_HCON_9057;
    confirmText = "온라인 견적서로 이동"
  } else { // 정상 처리
    confirmTitle = "견적 담기 완료"
    confirmMessage = ESTIMATE_CODE.ALT_HCON_9058;
    confirmText = "온라인 견적서로 이동"
  }

  // 컨펌 팝업
  const resultConfirm = await showCreateConfirm()

  if (resultConfirm) {
    if(tmpMessage === "QuantityOver") {
      // 담긴상품불러오기 팝업 노출
      showAddedGoodsImportPopup()
    } else {
      router.push({
        path: '/pc/order/estimate' // 온라인 견적서 이동
      })
    }
    return
  }
}

// 담긴상품불러오기 팝업
const popupAddedGoodsImportRef = ref<InstanceType<typeof HconAddedGoodsImport> | null>(null)
const showAddedGoodsImportPopup = () => {
  popupAddedGoodsImportRef.value?.handleOpen()
}

// 견적담기 완료 후 컨펌 팝업
const showCreateConfirm = async() => {
  const result = await showConfirm({
    title: confirmTitle,
    message: confirmMessage,
    confirmText: confirmText,
    cancelText: '취소'
  })
  return result;
}

// 환금성상품포함 시, 확인안내 팝업
const showCshabGdsInclConfirm = async () => {
  const message = ORDER_CODE.ALT_HCON_9120
  const result = await showConfirm({
    title: '구매 전 확인사항',
    message: message,
    confirmText: '확인완료',
    etcText: '1:1 문의',
    showEtcButton: true,
    showCancelButton: false,
    onEtc: () => {
      router.push({
        path: '/pc/inquiry/list'
        // state: {}
      })
    }
  })
  return result;
}

</script>
<style lang="scss" scoped>
@use "@/assets/scss/pc/order-hcon.scss" as *;
</style>